import { createGlobalStyle } from 'styled-components';
import { FONT_FACE } from '../../constants/theme';

export const GlobalStyle = createGlobalStyle`
  html {
    box-sizing: border-box;
    font-family: ${FONT_FACE.BOOK};
    line-height: 1.15;
    font-size: 10px; // for setting rem value local
  }

  *,*:before,*:after {
    box-shadow: inherit;
  }

  body {
    padding: 0;
    margin: 0;
  }

  a {
    text-decoration: none;
  }

  :root {
    color: ${props => props.theme.COLORS.PRIMARY.black};
    font-family: ${FONT_FACE.LIGHT};
    letter-spacing: .5px;
    line-height: 32px;
  }
`;